import dynamic from 'next/dynamic';

import React, { useState } from 'react';
const Button = dynamic(() => import('@/components/ui/Button'));
import Modal from "@/components/ui/Modal";
import Pagination from "@/components/ui/Pagination";
import { fetchData } from "@/supabase/functions";

const SearchTokenAllocationModal = ({ isOpen, onClose }) => {
  const [searchValue, setSearchValue] = useState('');
  const [searchResult, setSearchResult] = useState([]);
  const [searchWarning, setSearchWarning] = useState(false);
  const [noResults, setNoResults] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = searchResult.slice(indexOfFirstItem, indexOfLastItem);

  const isValidWalletAddress = (address) => {
    const walletRegex = /^0x[a-fA-F0-9]{40}$/;
    return walletRegex.test(address);
  };

  const handleSearch = async () => {
    if (!searchValue.trim()) {
      setSearchWarning(true);
      setSearchResult([]);
      setNoResults(false);
      return;
    }

    // New check using regex
    if (!isValidWalletAddress(searchValue.trim())) {
      setSearchWarning(true);
      setSearchResult([]);
      setNoResults(false);
      return;
    }

    try {
      const lowerCaseWallet = searchValue.toLowerCase();
      console.log("Searching for wallet:", lowerCaseWallet);
      
      const { data, error } = await fetchData('token_allocation', {
        select: '*',
        filter: { wallet: lowerCaseWallet }
      });

      if (error) {
        console.error("Error from fetchData:", error);
        throw error;
      }

      if (data && data.length > 0) {
        setSearchResult(data);
        setNoResults(false);
      } else {
        setSearchResult([]);
        setNoResults(true);
      }
      setSearchWarning(false);
    } catch (error) {
      console.error("Error in handleSearch:", error);
      setSearchResult([]);
      setNoResults(true);
      setSearchWarning(false);
    }
  };

  return (
    <Modal
      activeModal={isOpen}
      onClose={onClose}
      title={"Search Token Allocation"}
      className="max-w-2xl"
    >
      <div>
        <div className="flex items-center">
          <input
            type="text"
            value={searchValue}
            placeholder="Enter wallet address..."
            onChange={(e) => setSearchValue(e.target.value)}
            className="mr-2 px-2 py-1 border rounded-md w-full text-black-500"
          />
          <Button 
            onClick={handleSearch} 
            className="btn btn-primary btn-sm hover:bg-blue-600" 
            icon="heroicons-outline:search" 
          />
        </div>
        {searchWarning && (
          <p className="mt-6 text-red-500">Please enter a valid Ethereum wallet address.</p>
        )}
        {currentItems.length > 0 ? (
          <table className="mt-6 w-full table-auto border-collapse">
            <thead>
              <tr className='text-white text-sm xl:text-base gothamMedium'>
                <th className="px-4 py-2">Wallet</th>
                <th className="px-4 py-2">XSEED</th>
                <th className="px-4 py-2">Round</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.map((result, index) => (
                <tr key={index} className='text-sm xl:text-base bg-metaxseed-content-gray gothamBook'>
                  <td className="px-4 py-4">{result.wallet}</td>
                  <td className="px-4 py-4">{result.xseed}</td>
                  <td className="px-4 py-4">{result.round}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : noResults ? (
          <p className="mt-6 text-white">No results found.</p>
        ) : null}

        {searchResult.length > itemsPerPage && (
          <div className="mt-4 flex justify-center">
            <Pagination
              totalPages={Math.ceil(searchResult.length / itemsPerPage)}
              currentPage={currentPage}
              handlePageChange={handlePageChange}
            />
          </div>
        )}
        <div className="flex justify-end mt-6">
          <button 
            onClick={onClose} 
            className="bg-gray-500 text-white px-3 py-2 rounded-md hover:bg-gray-600"
          >
            Close
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default SearchTokenAllocationModal;
